/* istanbul ignore file */
export * from './ContentExternal';
